import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Input } from 'reactstrap';

import Table, { ExpandableRow } from '../../components/ExpandableTable';

import actions from './actions';

class Lista extends Component {
  constructor (props) {
    super(props);

    this.state = {
      data: {
        placa: '',
        modelo: '',
        cor: ''
      }
    };

    this.addVehicle = this.addVehicle.bind(this);
  }

  onChange (name) {
    return (e) => {
      let value = e.target.value.toUpperCase().replace(/^\s+|\s+(?=\s$|\s)/g, "");

      this.setState(state => ({
        ...state,
        data: {
          ...state.data,
          [name]: value
        }
      }));
    }
  }

  componentDidMount () {
    this.props.actions.onLoadListaVeiculos();
  }

  removeVehicle (item) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();

      this.props.actions.removeVehicle(item);
    };
  }

  resetValues () {
    this.setState(state => ({
      ...state,
      data: {
        placa: '',
        modelo: '',
        cor: ''
      }
    }));
  }

  addVehicle () {
    this.props.actions.addVehicle(this.state.data)
    .then(() => this.resetValues())
    .then(() => this.props.actions.onLoadListaVeiculosIfNeeded());
  }

  isValid () {
    const { placa , modelo, cor } = this.state.data;

    return 2 < placa.length && 2 < modelo.length && 2 < cor.length;
  }

  render() {
    const { data } = this.state;
    const { value: { result, fetching } } = this.props;

    return (
      <Table hover responsive size="sm">
        <thead>
          <tr>
            <th colSpan="4">Veículos</th>
          </tr>
          <tr>
            <th>Placa</th>
            <th>Modelo</th>
            <th>Cor</th>
            <th className="text-right">Ação</th>
          </tr>
        </thead>
        {result.map((v, i) => (
          <ExpandableRow key={i}>
            <td>{v.placa}</td>
            <td>{v.modelo}</td>
            <td>{v.cor}</td>
            <td className="text-right"><Button color="danger" size="sm" onClick={this.removeVehicle(v)}><span className="fa fa-minus"></span> <span className="d-none d-md-inline-block">Remover</span></Button></td>
          </ExpandableRow>
        ))}
        <tfoot>
          <tr>
            {['placa', 'modelo', 'cor'].map(v => (
              <th key={v}><Input required bsSize="sm" disabled={1 === fetching} maxLength={15} value={data[v]} onChange={this.onChange(v)} valid={2 < data[v].length} /></th>
            ))}
            <th className="text-right"><Button disabled={1 === fetching || !this.isValid()} color="success" size="sm" onClick={this.addVehicle}><span className="fa fa-plus"></span> <span className="d-none d-md-inline-block">Adicionar</span></Button></th>
          </tr>
        </tfoot>
      </Table>
    );
  }
}

let mapStateToProps = ({ unidade : { veiculos } }) => ({
  value: veiculos
});

let mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Lista);



// WEBPACK FOOTER //
// ./src/modules/unidade/ListaVeiculos.js